import { actionTypes } from '../actions';

export const uploadFiles = (state = {}, action) => {
	switch (action.type) {
	  	case actionTypes.UPLOAD_FILE_REQUSET:
			return {
        		...state,
				uploadFile: null,
				error: false,
				loading: true,
			}
		case actionTypes.UPLOAD_FILE_SUCCESS:
			return {
				...state,
				uploadFile: action.payload,
				error: false,
				loading: false,
			}
		case actionTypes.UPLOAD_FILE_FAILURE:
			return {
				...state,
				uploadFile: action.payload,
				error: true,
				loading: false,
			}
		case actionTypes.DELETE_FILE_REQUSET:
			return {
				...state,
				deleteFile: null,
				error: false,
				loading: true,
			}
		case actionTypes.DELETE_FILE_SUCCESS:
			return {
				...state,
				deleteFile: action.payload,
				error: false,
				loading: false,
			}
		case actionTypes.DELETE_FILE_FAILURE:
			return {
				...state,
				deleteFile: action.payload,
				error: true,
				loading: false,
			}	
	  default:
		return state;
	}
};


// WEBPACK FOOTER //
// ./reducers/files.js